import { createInstance } from './axios.api'
import { AreaInfoResponse } from '@/types/area-response.types'

export const getAreaInfo = async (addressId: number): Promise<AreaInfoResponse> => {
  //TODO: replace with normal named URI one when backend gateway is changed
  const axios = createInstance(process.env.VUE_APP_ADDRESS_SEARCH_API_URL)

  const { data } = await axios.get(`/area-info/${addressId}`)

  return data
}
